export const formatNumberToBRL = (value?: number, maxDigit?: number) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: maxDigit ?? 2 }).format(
        value ?? 0,
    ).toString()
}